import React, { useRef, useState } from 'react';
import Avatar from 'react-avatar';
import AccountService from '../../services/account.service';
import { API_URL } from '../../utils/apiConstant';

interface AvatarUploadProps {
  name: string;
  currentUrl: string | null;
  onSuccess: (url: string) => void;
}

const AvatarUpload: React.FC<AvatarUploadProps> = ({ name, currentUrl, onSuccess }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    setUploading(true);

    try {
      const res = await AccountService.uploadAvatar(file);
      onSuccess((res as any).data?.avatar_url ?? '');
    } catch {
      setPreview(null);
    } finally {
      setUploading(false);
    }
  };

  const toAbsolute = (fileName: string | null): string | undefined => {
    if (!fileName) return undefined;
    return fileName.startsWith('http') ? fileName : `${API_URL}/uploads/avatars/${fileName}`;
  };

  const displaySrc = preview ?? toAbsolute(currentUrl);

  return (
    <div
      className="position-relative d-inline-block cursor-pointer"
      style={{ borderRadius: '50%' }}
      onClick={() => !uploading && inputRef.current?.click()}
      title="Click to change avatar"
    >
      <Avatar
        name={name}
        src={displaySrc}
        size="80"
        maxInitials={2}
        round
      />
      <div
        className="position-absolute bottom-0 end-0 d-flex align-items-center justify-content-center"
        style={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          background: 'var(--bs-primary)',
          color: '#fff',
          fontSize: 12,
        }}
      >
        {uploading
          ? <span className="spinner-border spinner-border-sm" style={{ width: 12, height: 12 }} />
          : <i className="ri-camera-line" />
        }
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="d-none"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default AvatarUpload;
